import classNames from "classnames";
import { Error } from "@remo-co/ui-core/src/icons/Error";
import { Info } from "@remo-co/ui-core/src/icons/Info";
import { SUPPORT_STATUS } from "modules/systemCheck/constants";
import { useStyles } from "./styles";

interface Props {
  status: SUPPORT_STATUS;
}

const SystemCheckStatusIcon = ({ status }: Props): JSX.Element => {
  const styles = useStyles();

  switch (status) {
    case SUPPORT_STATUS.UNSUPPORTED:
      return (
        <Error
          className={classNames(styles.icon, styles.error)}
          data-testid="error-icon"
        />
      );
    case SUPPORT_STATUS.PARTIALLY_SUPPORTED:
      return (
        <Info
          className={classNames(styles.icon, styles.recommendation)}
          data-testid="recommendation-icon"
        />
      );
    default:
      return (
        <Info
          className={classNames(styles.icon, styles.recommendation)}
          data-testid="default-icon"
        />
      );
  }
};

export default SystemCheckStatusIcon;
